const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.2 24.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.1,16c0-3.3-2.7-6-6-6s-6,2.7-6,6h12,0Z",
    style: {
      fill: "#4e7698"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4,13.6c.2,0,.3.1.3.3-.1,5.7-4.8,10.3-10.6,10.3S-1.3,19.6-1.5,13.9c0-.2.1-.3.3-.3,0,0,20.6,0,20.6,0Z",
    style: {
      fill: "#27455e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.5.2h19.1c.1,0,.3.1.3.3v5.3c0,2.4-1.9,4.3-4.3,4.3H3.5c-2.4,0-4.3-1.9-4.3-4.3V.4c0-.1.1-.3.3-.3,0,0,0,0,0,0Z",
    style: {
      fill: "#1e374b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4,7.8c1.6,0,3-1.3,3-3s-1.3-3-3-3-3,1.3-3,3,1.3,3,3,3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8,7.8c1.6,0,3-1.3,3-3s-1.3-3-3-3-3,1.3-3,3,1.3,3,3,3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4,6.3c.9,0,1.5-.7,1.5-1.6s-.7-1.6-1.5-1.6-1.6.7-1.6,1.6.7,1.6,1.6,1.6Z",
    style: {
      fill: "#1e374b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8,6.3c.9,0,1.5-.7,1.5-1.6s-.7-1.6-1.5-1.6-1.5.7-1.5,1.6.7,1.6,1.5,1.6Z",
    style: {
      fill: "#1e374b"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5,11.8c.1,0,.2-.1.2-.2-.1-5.8-4.9-10.4-10.7-10.4S-1.5,5.8-1.6,11.5c0,.1.1.2.2.2h20.9,0Z",
    style: {
      fill: "#20374c"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5,11.8c.1,0,.2-.1.2-.2-.1-5.8-4.9-10.4-10.7-10.4S-1.5,5.8-1.6,11.5c0,.1.1.2.2.2h20.9,0Z",
    style: {
      fill: "#20374c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 7.2,
    r: 2.7,
    style: {
      fill: "#fffaf5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5,11.8c.1,0,.2-.1.2-.2-.1-5.8-4.9-10.4-10.7-10.4S-1.5,5.8-1.6,11.5c0,.1.1.2.2.2h20.9,0Z",
    style: {
      fill: "#20374c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 7.2,
    r: 2.7,
    style: {
      fill: "#fffaf5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.7,
    cy: 7.2,
    r: 2.7,
    style: {
      fill: "#fffaf5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5,11.8c.1,0,.2-.1.2-.2-.1-5.8-4.9-10.4-10.7-10.4S-1.5,5.8-1.6,11.5c0,.1.1.2.2.2h20.9,0Z",
    style: {
      fill: "#20374c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 7.2,
    r: 2.7,
    style: {
      fill: "#fffaf5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.7,
    cy: 7.2,
    r: 2.7,
    style: {
      fill: "#fffaf5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 7.2,
    r: 1.9,
    style: {
      fill: "#20374c"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5,11.8c.1,0,.2-.1.2-.2-.1-5.8-4.9-10.4-10.7-10.4S-1.5,5.8-1.6,11.5c0,.1.1.2.2.2h20.9,0Z",
    style: {
      fill: "#20374c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 7.2,
    r: 2.7,
    style: {
      fill: "#fffaf5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.7,
    cy: 7.2,
    r: 2.7,
    style: {
      fill: "#fffaf5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 7.2,
    r: 1.9,
    style: {
      fill: "#20374c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.7,
    cy: 7.2,
    r: 1.9,
    style: {
      fill: "#20374c"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5,11.8c.1,0,.2-.1.2-.2-.1-5.8-4.9-10.4-10.7-10.4S-1.5,5.8-1.6,11.5c0,.1.1.2.2.2h20.9,0Z",
    style: {
      fill: "#20374c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 7.2,
    r: 2.7,
    style: {
      fill: "#fffaf5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.7,
    cy: 7.2,
    r: 2.7,
    style: {
      fill: "#fffaf5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 7.2,
    r: 1.9,
    style: {
      fill: "#20374c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.7,
    cy: 7.2,
    r: 1.9,
    style: {
      fill: "#20374c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1,23.2c2.1,0,3.9-1.7,3.9-3.9s-1.7-3.9-3.9-3.9-3.9,1.7-3.9,3.9,1.7,3.9,3.9,3.9Z",
    style: {
      fill: "#9b9b96"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5,11.8c.1,0,.2-.1.2-.2-.1-5.8-4.9-10.4-10.7-10.4S-1.5,5.8-1.6,11.5c0,.1.1.2.2.2h20.9,0Z",
    style: {
      fill: "#20374c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 7.2,
    r: 2.7,
    style: {
      fill: "#fffaf5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.7,
    cy: 7.2,
    r: 2.7,
    style: {
      fill: "#fffaf5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 7.2,
    r: 1.9,
    style: {
      fill: "#20374c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.7,
    cy: 7.2,
    r: 1.9,
    style: {
      fill: "#20374c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1,23.2c2.1,0,3.9-1.7,3.9-3.9s-1.7-3.9-3.9-3.9-3.9,1.7-3.9,3.9,1.7,3.9,3.9,3.9Z",
    style: {
      fill: "#9b9b96"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.1,
    cy: 21.9,
    r: 0.6,
    style: {
      fill: "#fffaf5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5,11.8c.1,0,.2-.1.2-.2-.1-5.8-4.9-10.4-10.7-10.4S-1.5,5.8-1.6,11.5c0,.1.1.2.2.2h20.9,0Z",
    style: {
      fill: "#20374c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 7.2,
    r: 2.7,
    style: {
      fill: "#fffaf5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.7,
    cy: 7.2,
    r: 2.7,
    style: {
      fill: "#fffaf5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 7.2,
    r: 1.9,
    style: {
      fill: "#20374c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.7,
    cy: 7.2,
    r: 1.9,
    style: {
      fill: "#20374c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1,23.2c2.1,0,3.9-1.7,3.9-3.9s-1.7-3.9-3.9-3.9-3.9,1.7-3.9,3.9,1.7,3.9,3.9,3.9Z",
    style: {
      fill: "#9b9b96"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.1,
    cy: 21.9,
    r: 0.6,
    style: {
      fill: "#fffaf5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,11.8h.2c3.1,0,5.5,2.5,5.5,5.5v1.9c0,.1-.1.2-.2.2H3.7c-.1,0-.2-.1-.2-.2v-1.9c0-3.1,2.5-5.5,5.6-5.5h0Z",
    style: {
      fill: "#143223"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5,11.8c.1,0,.2-.1.2-.2-.1-5.8-4.9-10.4-10.7-10.4S-1.5,5.8-1.6,11.5c0,.1.1.2.2.2h20.9,0Z",
    style: {
      fill: "#20374c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 7.2,
    r: 2.7,
    style: {
      fill: "#fffaf5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.7,
    cy: 7.2,
    r: 2.7,
    style: {
      fill: "#fffaf5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 7.2,
    r: 1.9,
    style: {
      fill: "#20374c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.7,
    cy: 7.2,
    r: 1.9,
    style: {
      fill: "#20374c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1,23.2c2.1,0,3.9-1.7,3.9-3.9s-1.7-3.9-3.9-3.9-3.9,1.7-3.9,3.9,1.7,3.9,3.9,3.9Z",
    style: {
      fill: "#9b9b96"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.1,
    cy: 21.9,
    r: 0.6,
    style: {
      fill: "#fffaf5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,11.8h.2c3.1,0,5.5,2.5,5.5,5.5v1.9c0,.1-.1.2-.2.2H3.7c-.1,0-.2-.1-.2-.2v-1.9c0-3.1,2.5-5.5,5.6-5.5h0Z",
    style: {
      fill: "#143223"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8,4.1h5.3c.5,0,.9.4.9.9h0c0,.5-.4.9-.9.9H2.8c-.5,0-.9-.4-.9-.9h0c0-.5.4-.9.9-.9Z",
    style: {
      fill: "#20374c"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,.2h14.2c.1,0,.3.1.3.3v5.8c0,4.1-3.3,7.3-7.4,7.3h0c-4.1,0-7.4-3.3-7.4-7.4V.5c0-.1.1-.3.3-.3h0Z",
    style: {
      fill: "#2d1432"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_18"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 7.3,
    r: 2.3,
    style: {
      fill: "#fffaf5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.2,
    cy: 7.3,
    r: 2.3,
    style: {
      fill: "#fffaf5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 7.3,
    r: 1.6,
    style: {
      fill: "#2d1432"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.2,
    cy: 7.3,
    r: 1.6,
    style: {
      fill: "#2d1432"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_17"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 10.1,
    y1: 7.4,
    x2: 8.1,
    y2: 7.4,
    style: {
      fill: "none",
      stroke: "#fffaf5",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4,21.6h-6.7v-4.7c0-1.8,1.5-3.3,3.3-3.3h0c1.8,0,3.3,1.5,3.3,3.3,0,0,0,4.7,0,4.7Z",
    style: {
      fill: "#20374c"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.2,24.1c-1.8,0-3.2-1.4-3.2-3.2s1.4-3.2,3.2-3.2h11.8c1.8,0,3.2,1.4,3.2,3.2s-1.4,3.2-3.2,3.2c0,0-11.8,0-11.8,0Z",
    style: {
      fill: "#143223"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_14"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.2,
    cy: 21,
    r: 2.2,
    style: {
      fill: "#fffaf5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_13"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 21,
    r: 2.2,
    style: {
      fill: "#fffaf5"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBop);
export default __webpack_public_path__ + "static/media/Bop.90f4055889888c2bf4919eb8817e95d0.svg";
export { ForwardRef as ReactComponent };